import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FirebaseService } from '../../services/firebase.service';
import { GetDataService } from '../../services/getdata.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {


  searchTextChanged: Subject<string> = new Subject<string>();
  searchBarPlacholder = "Search here..";
  searchValue="";
  constructor(private firebaseService:FirebaseService,private getDataService: GetDataService,
    private router:Router,private ngxService:NgxUiLoaderService,private cookieService:CookieService) {
      this.getDataService.componentType.subscribe(response=>{
        if(response){
          this.searchValue ="";
          console.log('inside search text change',this.searchValue);
          this.getDataService.searchValue.next("");
        }
      })
      this.searchTextChanged.
      pipe(debounceTime(1000),distinctUntilChanged()).subscribe(search =>{
        if(search == "" || search.length>2){
          this.getDataService.searchValue.next(search);
        }
      });
    this.getDataService.getUsername().subscribe(response=>{
      if(response){
        this.username = response;
      }
    });
    this.getDataService.searchBarPlaceholder.subscribe(response=>{
      if(response){
        this.searchBarPlacholder = response;
        console.log('search bar',this.searchBarPlacholder);
      }
    })
   }

  ngOnInit(): void {
  }

  username = "";


  onLogout = () =>{
    try {
      this.ngxService.start();
      this.firebaseService.logout()
        .then(()=>{
          // on logout
          localStorage.clear();
          this.cookieService.deleteAll();
          this.router.navigateByUrl("/auth/login");
        })
        .catch(error=>{
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log('error',error);
        })
        this.ngxService.stop();
    } catch (error:any) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log('error',error);
      this.ngxService.stop();
    }
  }

  search(event:any){
    this.searchValue = event.target.value;
    this.searchTextChanged.next(event.target.value);
  }
  ngOnDestroy(){
    if(this.searchTextChanged){
      this.searchTextChanged.unsubscribe();
      this.searchValue = "";
    }
  }
}
